export const batch = [
    {
        cols: [
            {
                content: {
                    html: '<h1><span style="color: rgb(37, 88, 154)">NADPIS</span></h1>',
                    style: {},
                },
                style: {},
            },
        ],
    },
];

export default batch;
